import Home from '@/pages/Home.vue';
import Classes from '@/pages/classes/Classes.vue';
import SubjectsScales from '@/pages/marks/SubjectsScales.vue';
import Marks from '@/pages/marks/Marks.vue';
import StudentMarks from '@/pages/marks/StudentMarks.vue';
import UpdateStudentMarks from '@/pages/marks/UpdateStudentMarks.vue';
import QuestionsBank from '@/pages/questions-bank/QuestionsBank.vue';
import Question from '@/pages/questions-bank/Question.vue';
import Exams from '@/pages/exams/Exams.vue';
import Exam from '@/pages/exams/Exam.vue';
import ExamPreview from '@/pages/exams/ExamPreview.vue';
import { questionBankExamAndOnly } from '@/configs/general.configs';
export default [
	{
		path: '/',
		name: 'home',
		component: Home,
		redirect: !questionBankExamAndOnly ? '/classes/marks' : 'questions-bank',
		meta: {
			title: 'الصفحة الرئيسية',
		}
	},
	{
		path: '/classes',
		name: 'classes',
		component: Classes,
		meta: {
			title: 'الشعب',
		}
	},
	{
		path: '/classes/:classId?/:courseId?/subjects-scales',
		name: 'subjects-scales',
		component: SubjectsScales,
		meta: {
			title: 'ترميز العلامات',
		}
	},
	{
		path: '/classes/:classId?/:courseId?/marks',
		name: 'marks',
		component: Marks,
		meta: {
			title: 'العلامات',
		}
	},
	{
		path: '/classes/:classId/:courseId/student-marks/:studentId',
		name: 'student-marks',
		component: StudentMarks,
		meta: {
			title: 'علامات الطالب',
		}
	},
	{
		path: '/classes/:classId/:courseId/student-marks/:studentId/update',
		name: 'update-student-marks',
		component: UpdateStudentMarks,
		meta: {
			title: 'تحديث علامات الطالب',
		}
	},
	{
		path: '/questions-bank',
		name: 'questions-bank',
		component: QuestionsBank,
		meta: {
			title: 'بنك الأسئلة',
		}
	},
	{
		path: '/question/:state?',
		name: 'question',
		component: Question,
		meta: {
			title: 'سؤال',
		}
	},
	{
		path: '/exams',
		name: 'exams',
		component: Exams,
		meta: {
			title: 'الاختبارات',
		}
	},
	{
		path: '/exam/:id?',
		name: 'exam',
		component: Exam,
		meta: {
			title: 'اختبار',
		}
	},
	{
		path: '/exam-preview/:examId',
		name: 'exam-preview',
		component: ExamPreview,
		meta: {
			title: 'استعراض اختبار',
		}
	},
	{
		path: '*',
		redirect: '/'
	}
]
